<template>
    <div class="yd-dialog" v-show="dialogShow" @click="closeClickModal ? hideFn() : 'javascript:;'">
        <div class="yd-dialog-content" @click.stop="'javascript:;'" :class="contentClass">
            <slot></slot>
        </div>
    </div>
</template>
<script>
const _utils = require('@/components/utils');
const Component = _utils.createComponent('dialog');
export default Component({
    props:{
        show: Boolean,
        'close-click-modal':{
            type: Boolean,
            default: true
        }
    },
    data(){
        return {
            dialogShow: false,
            contentClass:''
        }
    },
    watch:{
        show(newVal){
            if(newVal){
                this.showFn();
            }else{
                this.hideFn();
            }
        }
    },
    methods:{
        showFn(){
            this.contentClass = 'yd-dialog-bottom-out';
            this.dialogShow = true;
            this.$emit('update:show', true);
        },
        hideFn(){
            this.contentClass = 'yd-dialog-bottom-in';
            setTimeout(() => {
                this.dialogShow = false;
                this.contentClass = '';
                this.$emit('update:show', false);
                this.$emit('close-animation-end');
            }, 300);
        }
    }
})
</script>
<style lang="scss">
.yd-dialog{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.40);
    z-index: 900;
    .yd-dialog-content{
        height: auto;
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px -36px 64px -8px rgba(136,136,136,0.25);
        border-radius: 40px 40px 0px 0px;
        position: absolute;
        bottom: 0;
        left: 0;
        box-sizing: border-box;
        padding-bottom: 68px;
        &.yd-dialog-bottom-out{
            transform: translateY(0%);
            animation: yd-dialog-bottom-out 0.3s linear;
        }
        &.yd-dialog-bottom-in{
            transform: translateY(100%);
            animation: yd-dialog-bottom-in 0.3s linear;
        }
    }
}
@keyframes yd-dialog-bottom-out{
    0%{
        transform: translateY(100%);
    }
    100%{
        transform: translateY(0%);
    }
}
@keyframes yd-dialog-bottom-in{
    0%{
        transform: translateY(0%);
    }
    100%{
        transform: translateY(100%);
    }
}
</style>